
import React, { useEffect, useState } from "react";
import axios from "axios";
import hostlink from "../Hostlink/hostlink";
import { toast } from "react-toastify";

const EmployeeSalaryPayment = () => {

    const user = JSON.parse(
        localStorage.getItem("MYPCKARTUSER") || "{}"
    );

    const shopid = localStorage.getItem('MYPCKARTUSER') ? JSON.parse(localStorage.getItem('MYPCKARTUSER'))[0].id : '0';

    const currentDate = new Date();

    const [month, setMonth] = useState(
        currentDate.getMonth() + 1
    );

    const [year, setYear] = useState(
        currentDate.getFullYear()
    );

    const [salaryList, setSalaryList] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedSalary, setSelectedSalary] =
        useState(null);

    const [paymentAmount, setPaymentAmount] =
        useState("");

    const [narration, setNarration] =
        useState("");

    const loadSalary = async () => {

        try {

            setLoading(true);

            const response = await axios.get(
                `${hostlink}/employee-salary/month`,
                {
                    params: {
                        shopid,
                        month,
                        year
                    }
                }
            );

            setSalaryList(response.data || []);

        } catch (error) {

            console.error(error);
            toast.error("Unable to load salary");

        } finally {

            setLoading(false);
        }
    };

    useEffect(() => {
        loadSalary();
    }, [month, year]);

    const openPayment = salary => {

        const balance =
            Number(salary.netSalary || 0) -
            Number(salary.paidAmount || 0);

        setSelectedSalary(salary);
        setPaymentAmount(
            balance > 0 ? balance : ""
        );

        setNarration(
            `Salary payment - ${month}/${year}`
        );
    };

    const savePayment = async e => {

        e.preventDefault();

        if (!selectedSalary) {
            return;
        }

        const amount =
            Number(paymentAmount || 0);

        const netSalary =
            Number(selectedSalary.netSalary || 0);

        const alreadyPaid =
            Number(selectedSalary.paidAmount || 0);

        const balance =
            netSalary - alreadyPaid;

        if (amount <= 0) {
            toast.error("Enter valid payment amount");
            return;
        }

        if (amount > balance) {
            toast.error(
                "Payment cannot be greater than balance"
            );
            return;
        }

        try {

            const newPaid =
                alreadyPaid + amount;

            const newBalance =
                netSalary - newPaid;

            const status =
                newBalance <= 0
                    ? "PAID"
                    : "PARTIAL";

            /*
             * This endpoint should post the payment
             * to your AccountTransaction table.
             *
             * Expected backend endpoint:
             * POST /employee-salary/payment
             */

            await axios.post(
                `${hostlink}/employee-salary/payment`,
                {
                    salaryid: selectedSalary.id,
                    employeeid: selectedSalary.employeeid,
                    shopid,
                    amount,
                    paymentdate: new Date()
                        .toISOString()
                        .split("T")[0],
                    narration,
                    status
                }
            );

            /*
             * Update local salary list.
             */

            setSalaryList(prev =>
                prev.map(item =>
                    item.id === selectedSalary.id
                        ? {
                            ...item,
                            paidAmount: newPaid,
                            balanceAmount: newBalance,
                            status
                        }
                        : item
                )
            );

            toast.success("Salary payment saved");

            setSelectedSalary(null);
            setPaymentAmount("");
            setNarration("");

            loadSalary();

        } catch (error) {

            console.error(error);
            toast.error(
                error?.response?.data ||
                "Unable to save salary payment"
            );
        }
    };

    const totalSalary = salaryList.reduce(
        (sum, x) =>
            sum + Number(x.netSalary || 0),
        0
    );

    const totalPaid = salaryList.reduce(
        (sum, x) =>
            sum + Number(x.paidAmount || 0),
        0
    );

    const totalBalance = salaryList.reduce(
        (sum, x) =>
            sum +
            (
                Number(x.netSalary || 0) -
                Number(x.paidAmount || 0)
            ),
        0
    );

    const getEmployeeName = item => {

        return (
            item.employeeName ||
            item.accname ||
            `Employee #${item.employeeid}`
        );
    };

    return (
        <div className="container-fluid py-3 payment-page">

            <div className="payment-header mb-3">

                <div className="header-title">

                    <div className="header-icon">
                        <i className="fa-solid fa-money-bill-transfer"></i>
                    </div>

                    <div>
                        <h4>Salary Payment</h4>
                        <small>
                            Pay employee salary
                        </small>
                    </div>

                </div>


                <div className="month-selector">

                    <select
                        className="form-select"
                        value={month}
                        onChange={e =>
                            setMonth(Number(e.target.value))
                        }
                    >
                        {[
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ].map((name, index) => (
                            <option
                                key={name}
                                value={index + 1}
                            >
                                {name}
                            </option>
                        ))}
                    </select>

                    <select
                        className="form-select"
                        value={year}
                        onChange={e =>
                            setYear(Number(e.target.value))
                        }
                    >
                        {[2024, 2025, 2026, 2027, 2028].map(y => (
                            <option key={y} value={y}>
                                {y}
                            </option>
                        ))}
                    </select>

                </div>

            </div>


            <div className="row g-3 mb-3">

                <div className="col-md-4">
                    <div className="summary-card">
                        <small>Total Salary</small>
                        <h4>
                            ₹ {totalSalary.toLocaleString("en-IN")}
                        </h4>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="summary-card">
                        <small>Paid</small>
                        <h4 className="paid">
                            ₹ {totalPaid.toLocaleString("en-IN")}
                        </h4>
                    </div>
                </div>

                <div className="col-md-4">
                    <div className="summary-card">
                        <small>Outstanding</small>
                        <h4 className="balance">
                            ₹ {totalBalance.toLocaleString("en-IN")}
                        </h4>
                    </div>
                </div>

            </div>


            <div className="payment-container">

                <div className="payment-toolbar">

                    <div>
                        <h5>
                            <i className="fa-solid fa-users me-2"></i>
                            Salary Payable
                        </h5>

                        <small>
                            {salaryList.length} employees
                        </small>
                    </div>

                    <button
                        className="btn btn-outline-dark btn-sm"
                        onClick={loadSalary}
                    >
                        <i className="fa-solid fa-rotate me-1"></i>
                        Refresh
                    </button>

                </div>


                <div className="table-responsive">

                    <table className="table payment-table mb-0">

                        <thead>
                            <tr>
                                <th>Employee</th>
                                <th>Net Salary</th>
                                <th>Paid</th>
                                <th>Balance</th>
                                <th>Status</th>
                                <th className="text-end">Action</th>
                            </tr>
                        </thead>

                        <tbody>

                            {loading ? (

                                <tr>
                                    <td
                                        colSpan="6"
                                        className="text-center py-5"
                                    >
                                        <div className="spinner-border"></div>
                                    </td>
                                </tr>

                            ) : salaryList.length === 0 ? (

                                <tr>
                                    <td
                                        colSpan="6"
                                        className="text-center py-5 text-muted"
                                    >
                                        No salary processed for this month
                                    </td>
                                </tr>

                            ) : (

                                salaryList.map(item => {

                                    const balance =
                                        Number(item.netSalary || 0) -
                                        Number(item.paidAmount || 0);

                                    const status =
                                        balance <= 0
                                            ? "PAID"
                                            : Number(
                                                item.paidAmount || 0
                                            ) > 0
                                                ? "PARTIAL"
                                                : "OPEN";

                                    return (
                                        <tr key={item.id}>

                                            <td>

                                                <div className="employee-cell">

                                                    <div className="avatar">
                                                        {getEmployeeName(item)
                                                            .charAt(0)
                                                            .toUpperCase()}
                                                    </div>

                                                    <div>
                                                        <strong>
                                                            {getEmployeeName(item)}
                                                        </strong>

                                                        <small>
                                                            #{item.employeeid}
                                                        </small>
                                                    </div>

                                                </div>

                                            </td>

                                            <td className="fw-bold">
                                                ₹{" "}
                                                {Number(
                                                    item.netSalary || 0
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td className="text-success fw-bold">
                                                ₹{" "}
                                                {Number(
                                                    item.paidAmount || 0
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td className="text-danger fw-bold">
                                                ₹{" "}
                                                {balance.toLocaleString(
                                                    "en-IN"
                                                )}
                                            </td>

                                            <td>

                                                <span
                                                    className={`status-badge ${status.toLowerCase()}`}
                                                >
                                                    {status}
                                                </span>

                                            </td>

                                            <td className="text-end">

                                                <button
                                                    className="btn btn-sm btn-dark"
                                                    disabled={balance <= 0}
                                                    onClick={() =>
                                                        openPayment(item)
                                                    }
                                                >
                                                    <i className="fa-solid fa-money-bill me-1"></i>
                                                    Pay
                                                </button>

                                            </td>

                                        </tr>
                                    );

                                })

                            )}

                        </tbody>

                    </table>

                </div>

            </div>


            {selectedSalary && (

                <div className="modal-backdrop-custom">

                    <div className="payment-modal">

                        <div className="modal-head">

                            <div>
                                <h5>Salary Payment</h5>
                                <small>
                                    {getEmployeeName(selectedSalary)}
                                </small>
                            </div>

                            <button
                                className="btn-close"
                                onClick={() =>
                                    setSelectedSalary(null)
                                }
                            ></button>

                        </div>


                        <form onSubmit={savePayment}>

                            <div className="modal-body-custom">

                                <div className="payment-info">

                                    <div>
                                        <small>Net Salary</small>
                                        <strong>
                                            ₹{" "}
                                            {Number(
                                                selectedSalary.netSalary ||
                                                0
                                            ).toLocaleString("en-IN")}
                                        </strong>
                                    </div>

                                    <div>
                                        <small>Already Paid</small>
                                        <strong className="text-success">
                                            ₹{" "}
                                            {Number(
                                                selectedSalary.paidAmount ||
                                                0
                                            ).toLocaleString("en-IN")}
                                        </strong>
                                    </div>

                                    <div>
                                        <small>Balance</small>
                                        <strong className="text-danger">
                                            ₹{" "}
                                            {(
                                                Number(
                                                    selectedSalary.netSalary ||
                                                    0
                                                ) -
                                                Number(
                                                    selectedSalary.paidAmount ||
                                                    0
                                                )
                                            ).toLocaleString("en-IN")}
                                        </strong>
                                    </div>

                                </div>


                                <div className="mt-4">

                                    <label>Payment Amount</label>

                                    <input
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        className="form-control payment-amount"
                                        value={paymentAmount}
                                        onChange={e =>
                                            setPaymentAmount(
                                                e.target.value
                                            )
                                        }
                                    />

                                </div>


                                <div className="mt-3">

                                    <label>Payment Account</label>

                                    <select className="form-select">

                                        <option value="CASH">
                                            Cash
                                        </option>

                                        <option value="BANK">
                                            Bank
                                        </option>

                                    </select>

                                </div>


                                <div className="mt-3">

                                    <label>Narration</label>

                                    <textarea
                                        rows="3"
                                        className="form-control"
                                        value={narration}
                                        onChange={e =>
                                            setNarration(
                                                e.target.value
                                            )
                                        }
                                    ></textarea>

                                </div>

                            </div>


                            <div className="modal-footer-custom">

                                <button
                                    type="button"
                                    className="btn btn-light"
                                    onClick={() =>
                                        setSelectedSalary(null)
                                    }
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-dark px-4"
                                >
                                    <i className="fa-solid fa-check me-2"></i>
                                    Save Payment
                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            )}


            <style>{`

                .payment-page {
                    min-height: 100vh;
                    background: #f5f7fb;
                }

                .payment-header {
                    padding: 20px 24px;
                    border-radius: 18px;
                    background: linear-gradient(
                        135deg,
                        #151c2c,
                        #293f62
                    );
                    color: white;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .header-title {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                }

                .header-icon {
                    width: 48px;
                    height: 48px;
                    border-radius: 14px;
                    background: rgba(255,255,255,.12);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 21px;
                }

                .payment-header h4 {
                    margin: 0;
                    font-weight: 700;
                }

                .payment-header small {
                    opacity: .7;
                }

                .month-selector {
                    display: flex;
                    gap: 8px;
                }

                .month-selector select {
                    min-width: 120px;
                    border: 0;
                }

                .summary-card {
                    background: white;
                    padding: 17px;
                    border-radius: 15px;
                    box-shadow: 0 5px 20px rgba(0,0,0,.05);
                }

                .summary-card small {
                    color: #8992a1;
                }

                .summary-card h4 {
                    margin: 5px 0 0;
                    font-weight: 800;
                }

                .summary-card .paid {
                    color: #198754;
                }

                .summary-card .balance {
                    color: #dc3545;
                }

                .payment-container {
                    background: white;
                    border-radius: 17px;
                    overflow: hidden;
                    box-shadow: 0 5px 20px rgba(0,0,0,.05);
                }

                .payment-toolbar {
                    padding: 17px 20px;
                    border-bottom: 1px solid #edf0f4;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .payment-toolbar h5 {
                    margin: 0;
                    font-weight: 700;
                }

                .payment-toolbar small {
                    color: #8b94a3;
                }

                .payment-table thead th {
                    background: #f7f8fa;
                    border: 0;
                    padding: 13px;
                    color: #687284;
                    font-size: 11px;
                }

                .payment-table tbody td {
                    padding: 14px;
                    border-color: #edf0f4;
                    vertical-align: middle;
                }

                .employee-cell {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }

                .avatar {
                    width: 38px;
                    height: 38px;
                    border-radius: 50%;
                    background: #edf2ff;
                    color: #4057c9;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 800;
                }

                .employee-cell strong {
                    display: block;
                }

                .employee-cell small {
                    color: #99a1ae;
                }

                .status-badge {
                    padding: 5px 10px;
                    border-radius: 20px;
                    font-size: 10px;
                    font-weight: 700;
                }

                .status-badge.paid {
                    background: #eaf8ef;
                    color: #198754;
                }

                .status-badge.partial {
                    background: #fff5dc;
                    color: #d39400;
                }

                .status-badge.open {
                    background: #fdecec;
                    color: #dc3545;
                }

                .modal-backdrop-custom {
                    position: fixed;
                    inset: 0;
                    background: rgba(15,20,30,.55);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 2000;
                    padding: 20px;
                }

                .payment-modal {
                    width: 100%;
                    max-width: 520px;
                    background: white;
                    border-radius: 18px;
                    overflow: hidden;
                    box-shadow: 0 20px 60px rgba(0,0,0,.25);
                }

                .modal-head {
                    padding: 18px 20px;
                    background: #172033;
                    color: white;
                    display: flex;
                    justify-content: space-between;
                }

                .modal-head h5 {
                    margin: 0;
                }

                .modal-head small {
                    opacity: .65;
                }

                .modal-body-custom {
                    padding: 20px;
                }

                .payment-info {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 8px;
                }

                .payment-info > div {
                    background: #f7f8fa;
                    padding: 12px;
                    border-radius: 10px;
                }

                .payment-info small {
                    display: block;
                    color: #8b94a3;
                    font-size: 10px;
                }

                .payment-info strong {
                    display: block;
                    margin-top: 4px;
                }

                .payment-amount {
                    font-size: 20px;
                    font-weight: 700;
                    padding: 12px;
                }

                label {
                    font-size: 12px;
                    font-weight: 600;
                    color: #657083;
                    margin-bottom: 6px;
                }

                .modal-footer-custom {
                    border-top: 1px solid #edf0f4;
                    padding: 15px 20px;
                    display: flex;
                    justify-content: flex-end;
                    gap: 8px;
                }

            `}</style>

        </div>
    );
};

export default EmployeeSalaryPayment;

